import {
  setCurrentShopData,
  setGlobalCurrentShopData,
  ShopData,
} from "@/utils/storage";
import { useCallback } from "react";
import { useModel } from "@@/exports";

/**
 * 设置当前店铺
 */
export const useExchangeShop = () => {
  const { initialState, refresh, setInitialState } = useModel("@@initialState");
  const { getPingAnCheckData } = useModel("useCommonModel");

  return useCallback(
    async (shopId: number) => {
      const shop: ShopData =
        initialState?.currentUser?.suppliers?.find(
          (item) => item.shopId === shopId,
        ) ?? {};
      // 设置当前店铺数据
      setCurrentShopData(shop);
      // 设置全局当前店铺数据
      setGlobalCurrentShopData(shop);
      setInitialState((s) => ({ ...s, currentShop: shop }));
      await refresh();
      getPingAnCheckData();
    },
    [initialState, refresh, getPingAnCheckData, setInitialState],
  );
};
